import React from 'react';
import { cn } from '../../lib/utils';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'elevated' | 'outline';
  padding?: 'none' | 'sm' | 'md' | 'lg';
}
export function Card({
  className,
  variant = 'default',
  padding = 'md',
  children,
  ...props
}: CardProps) {
  const variants = {
    default: 'bg-white border border-slate-200',
    elevated: 'bg-white shadow-lg border-transparent',
    outline: 'bg-transparent border-2 border-slate-200'
  };
  const paddings = {
    none: 'p-0',
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-6'
  };
  return <div className={cn('rounded-2xl overflow-hidden', variants[variant], paddings[padding], className)} {...props} data-id="element-678">
      {children}
    </div>;
}